import { IconNames } from '@blueprintjs/icons';
import { Icon } from '@strata/react-status-icons';
import classNames from 'classnames';
import { getIn, useFormikContext } from 'formik';
import PropTypes from 'prop-types';

export const CardOptions = ({
    arrayHelpers,
    index,
    elementPath,
    cardPreview,
    duplicateElement,
    getId,
    onCardDelete = undefined,
    editCallback = undefined,
}) => {
    const formik = useFormikContext();
    const cardId = getId(elementPath);
    const canRemove = getIn(formik.values, arrayHelpers.name).length > 1;

    return (
        <div className="sds_dynamic-card__options">
            {editCallback && (
                <Icon
                    icon={IconNames.EDIT}
                    onClick={(event) => {
                        event.stopPropagation();
                        editCallback(getId(elementPath));
                    }}
                    title="Edit"
                />
            )}
            <Icon
                icon={IconNames.DUPLICATE}
                onClick={(event) => {
                    event.stopPropagation();
                    arrayHelpers.insert(
                        index + 1,
                        duplicateElement(getIn(formik.values, elementPath)),
                    );
                }}
                title="Duplicate"
            />
            <Icon
                icon={IconNames.TRASH}
                onClick={
                    canRemove
                        ? (event) => {
                              event.stopPropagation();
                              const currentCard = getIn(formik.values, elementPath);
                              const deleteCard = () => {
                                  arrayHelpers.remove(index);
                              };
                              if (onCardDelete) {
                                  onCardDelete({
                                      cardId,
                                      elementPath,
                                      cardPreview,
                                      currentCard,
                                      deleteCard,
                                  });
                              } else {
                                  deleteCard();
                              }
                          }
                        : undefined
                }
                className={classNames({
                    'sds_dynamic-card__options--disabled': !canRemove,
                })}
                title="Remove"
            />
        </div>
    );
};

CardOptions.propTypes = {
    arrayHelpers: PropTypes.shape({
        name: PropTypes.string,
        swap: PropTypes.func,
        remove: PropTypes.func,
        insert: PropTypes.func,
    }).isRequired,
    index: PropTypes.number.isRequired,
    elementPath: PropTypes.string.isRequired,
    cardPreview: PropTypes.node.isRequired,
    duplicateElement: PropTypes.func.isRequired,
    getId: PropTypes.func.isRequired,
    onCardDelete: PropTypes.func,
    editCallback: PropTypes.func,
};
